import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { displayNotification, sendAPIRequest } from 'helpers';

export const fetchReportLists = createAsyncThunk('report/fetchReportLists', async (args, thunkAPI) => {
    try {
        const { mode, id } = args;
        let url = '';
        if (mode == "template") {
            url = `/api/pvsa/form-table-lists?template-id=${id}`;
        } else if (mode == "report") {
            url = `/api/pvsa/report-form-table-lists?report-id=${id}`;
        }
        const req = await sendAPIRequest(url);
        const ret = await req.json();
        if (ret.success) {
            return ret.data;
        } else {
            displayNotification("error", "Error loading Report List Data [B]");
            return [];
        }
    } catch (e) {
        console.log(e);
        displayNotification("error", "Error loading Report List Data [F]");
        return [];
    }
});

export const reportSlice = createSlice({
  name: 'report',
  initialState: {
    lists: [],
    ids:[]
  },
  reducers: {
     setIdsState: (state, payload = true) => {
            state.ids = payload.payload;
        },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchReportLists.fulfilled, (state, action) => {
        state.lists = action.payload;
    });
  },
});
export const {setIdsState} = reportSlice.actions

export default reportSlice.reducer